import type { KeyboardEvent, MouseEvent } from 'react';

export const isMouseEvent = (
  event: MouseEvent | KeyboardEvent
): event is MouseEvent => 'pageX' in event;
